import gql from 'graphql-tag'

export const ADD_NEW_FORUM_TOPIC = gql`
  mutation adicionaTopicoForum($titulo: String!, $descricao: String!, $categoria_id: String!, $curso_id: String, $modulo_id: String) {
    adicionaTopicoForum(titulo: $titulo, descricao: $descricao, categoria_id: $categoria_id, curso_id: $curso_id, modulo_id: $modulo_id) {
      _id
      titulo
      descricao
      categoria_id
    }
  }
`

export const ADD_TOPIC_VISUALIZATION = gql`
  mutation adicionaVisualizacaoTopico($_id: String!) {
    adicionaVisualizacaoTopico(_id: $_id)
  }
`

export const DELETA_TOPICO = gql`
  mutation deletaTopicoForum($_id: String!) {
    deletaTopicoForum(_id: $_id)
  }
`

export const DELETA_RESPOSTA_TOPICO = gql`
  mutation deletaRespostaTopicoForum($_id: String!) {
    deletaRespostaTopicoForum(_id: $_id)
  }
`

export const RESPONDE_TOPICO_FORUM = gql`
  mutation respondeTopicoForum($topico_id: String!, $descricao: String!, $curso_id: String) {
    respondeTopicoForum(topico_id: $topico_id, descricao: $descricao, curso_id: $curso_id) {
      _id
      descricao
      topico_id
    }
  }
`

export const RESPONDE_RESPOSTA_FORUM = gql`
  mutation respondeRespostaForum($resposta_id: String!, $topico_id: String!, $descricao: String!, $curso_id: String) {
    respondeRespostaForum(resposta_id: $resposta_id, descricao: $descricao, topico_id: $topico_id, curso_id: $curso_id) {
      _id
      descricao
      resposta_id
    }
  }
`
